import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const LandlordAuthContext = createContext(null);

export function LandlordAuthProvider({ children }) {
  const [landlord, setLandlord] = useState(null);

  const refetch = useCallback(async () => {
    try {
      const { data } = await api.get("/landlord/auth/me");
      setLandlord(data);
    } catch {
      setLandlord(false);
    }
  }, []);

  useEffect(() => { refetch(); }, [refetch]);

  const login = useCallback(async (login_code, pin) => {
    try {
      await api.post("/landlord/auth/login", { login_code, pin });
      await refetch();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  }, [refetch]);

  const logout = useCallback(async () => {
    try { await api.post("/landlord/auth/logout"); } catch (e) { /* noop */ }
    setLandlord(false);
  }, []);

  return (
    <LandlordAuthContext.Provider value={{ landlord, login, logout, refetch }}>
      {children}
    </LandlordAuthContext.Provider>
  );
}

export function useLandlordAuth() {
  return useContext(LandlordAuthContext);
}
